import { trigger, state, style, transition, animate } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AlertController, IonRouterOutlet, LoadingController, ModalController, ToastController, Config } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { FiltrosComponent } from '../modal/filtros/filtros.component';
import { ApiService } from '../services/api.service';
import { MqttService } from '../services/mqtt.service';
import { CesionComponent } from '../cesion/cesion.component';


@Component({
  selector: 'app-compras',
  templateUrl: './compras.page.html',
  styleUrls: ['./compras.page.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: "hidden" })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ComprasPage implements OnInit {
  @ViewChild("paginator") paginator: MatPaginator;

  displayedColumns: string[] = ['proveedor', 'especie', 'cantidad', 'precio', 'importe'];
  displayedFooterColumns: string[] = ['proveedor', 'cantidad', 'importe'];

  /*,'star'*/
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  dataAdjudica: any;
  dataSource;
  expandedElement: any;
  compras: any = [];
  sortedData;
  fecha = new Date();
  fechaSend;
  //fechaSend = 'all'
  especieSend = "all";
  proveedorSend = "all";

  cantidadFinal;
  importeFinal;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  filteredProveedores: any;
  filteredEspecies: any;
  modalFiltro: HTMLIonModalElement;
  fechaInterval;
  fechaCabecera;

  user: User = {
    username: null,
    userId: null,
    clientes: null,
    roles: null,
  };


  subscriptions: Subscription[] = [];
  constructor(
    public alertCtrl: AlertController,
    public apiService: ApiService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public router: Router,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public routerOutlet: IonRouterOutlet,
    public toastCtrl: ToastController,
    public config: Config,
    public storage: Storage,
    public mqttService: MqttService,
  ) {
    this.fechaInterval = setInterval(() => {
      this.fechaCabecera = new Date();
    }, 1000);
    this.fechaSend = this.datePipe.transform(new Date(), "dd-MM-yyyy");
  }

  ngOnInit() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
      console.log(this.user)
      this.getData();
    });
    if (this.dataSource) { this.dataSource.sort = this.sort; }
  }

  ionViewWillEnter() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
    });
  }

  ionViewDidLeave() {
    clearInterval(this.fechaInterval);
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }

  async cargaModal() {
    let dialogConfig = new MatDialogConfig();
    //this.partida["timer"] = this.tiempoEspera
    dialogConfig.autoFocus = true;
    dialogConfig.width = "500px"
    dialogConfig.height = "350px"
    dialogConfig.disableClose = true
    dialogConfig.panelClass = 'custom-dialog-container'
    const aux = this.dialog.open(FiltrosComponent, dialogConfig);
    aux.afterClosed().subscribe(
      data => {
        if (data) {
          this.fechaSend = this.datePipe.transform(data["fecha"], "dd-MM-yyyy");
          this.proveedorSend = data["proveedor"]
          this.especieSend = data["especie"]
        } else {
          this.fechaSend = "all"
          this.especieSend = "all"
          this.proveedorSend = "all"
        }
        this.getData()
      })
  }

  eliminarFiltro() {
    this.fechaSend = "all"
    this.proveedorSend = "all"
    this.especieSend = "all"
    this.getData()
  }

  clear() {
    this.fecha = null;
    this.fechaSend = "all";
    this.getData();
  }

  getTotalesCantidad() {
    if (this.compras != null && this.compras != undefined) {
      return this.compras.map(t => Number.parseFloat(t.cantidadkm.toFixed(2))).reduce((acc, value) => (acc + value), 0);
    }
    return 0;
  }

  getTotalesImporte() {
    if (this.compras != null && this.compras != undefined) {
      return this.compras.map(t => Number.parseFloat(t.importe.toFixed(2))).reduce((acc, value) => (acc + value), 0);
    }
    return 0;
  }

  onBlur(event) {
    this.fecha = event.value;
    this.fechaSend = this.fillLeft(String(event.value.date())) + "-" + this.fillLeft(String(event.value.month() + 1)) + "-" + event.value.year();
    this.getData()
  }

  getData() {
    this.apiService.getAdjudicacionesFecha(this.user.userId, this.fechaSend, this.proveedorSend, this.especieSend).subscribe((data: any) => {
      if (data.adjudicaciones) {
        this.compras = data.adjudicaciones;
      } else {
        this.compras = [];
      }
      this.dataSource = new MatTableDataSource(data.adjudicaciones);
      this.dataSource.sort = this.sort;
      this.cantidadFinal = this.getTotalesCantidad();
      this.importeFinal = this.getTotalesImporte();
    });
  }

  fillLeft(text) {
    while (text.length < 2) {
      text = "0" + text;
    }
    return text;
  }




  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'fecha':
          return this.compare(a.fecha, b.fecha, isAsc);
        case 'proveedor':
          return this.compare(a.proveedor, b.proveedor, isAsc);
        case 'especie':
          return this.compare(a.especie, b.especie, isAsc);
        case 'cantidad':
          return this.compare(a.cantidad, b.cantidad, isAsc);
        case 'precio':
          return this.compare(a.precio, b.precio, isAsc);
        case 'importe':
          return this.compare(a.importe, b.importe, isAsc);
        default:
          return 0;
      }
    });
  }


  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  async openCesion(adj){

    let modalCantidad = await this.modalCtrl.create({ component: CesionComponent, componentProps: adj, backdropDismiss: false,cssClass:'modal-cesion'});
    modalCantidad.onDidDismiss().then((data) => {
      this.getData()
  });
    await modalCantidad.present();
  }
}